application.register("lib-slider", class extends Stimulus.Controller {
    connect() {
        let slider = this.element.querySelector("[data-lib-slider]"),
            slider_caption = this.element.querySelector("[data-lib-slider-caption]");

        cssLoaded(()=>{
            inView(this.element,()=>{
                importStyle(cdnjs.slick_css);
                importStyle(cdnjs.slick_theme);
                importScript([cdnjs.jquery, cdnjs.slick],()=>{
                    $(slider).slick({
                        dots: false,
                        infinite: true,
                        speed: 500,
                        fade: true,
                        arrows: true,
                        cssEase: 'linear',
                        prevArrow: '<button type="button" class="slick-prev"></button>',
                        nextArrow: '<button type="button" class="slick-next"></button>',
                        asNavFor: (slider_caption !== null) ? $(slider_caption) : null
                    });

                    $(slider).on('beforeChange', function(){
                        $(slider).find(".slick-active").next().find("img").addClass("lazyload");
                    });

                    if(slider_caption !== null) {
                        $(slider_caption).slick({
                            dots: false,
                            infinite: true,
                            speed: 500,
                            fade: true,
                            arrows: false,
                            cssEase: 'linear',
                            asNavFor: slider
                        });
                    }
                });
            });
        })
    }
});